import ReactApexChart from "react-apexcharts";

const MenuItemBarChart = ({ title, categories, data, seriesName, emptyLabel, showValues = false }) => {
  if (!data?.length) {
    return <p className="text-muted mb-0">{emptyLabel}</p>;
  }

  const options = {
    chart: {
      toolbar: { show: false },
      fontFamily: "inherit",
    },
    colors: ["#ce9558"],
    plotOptions: {
      bar: {
        columnWidth: "45%",
        borderRadius: 3,
      },
    },
    dataLabels: { enabled: showValues },
    legend: { show: false },
    xaxis: {
      categories,
      labels: {
        rotate: -35,
        trim: true,
        hideOverlappingLabels: false,
      },
    },
    yaxis: {
      labels: {
        formatter: (value) => Math.round(value),
      },
    },
    title: {
      text: title,
      style: { fontWeight: 500, fontSize: "15px" },
    },
    tooltip: {
      y: {
        formatter: (value) => String(value),
      },
    },
  };

  return (
    <ReactApexChart
      dir="ltr"
      className="apex-charts"
      type="bar"
      height={320}
      series={[{ name: seriesName, data }]}
      options={options}
    />
  );
};

export default MenuItemBarChart;
